import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  employees: [],
  selectedEmployee: null,
  loading: false,
  error: null,
  filters: {
    department: '',
    status: '',
    search: '',
  },
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
}

const employeeSlice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    setEmployees: (state, action) => {
      state.employees = action.payload
    },
    setSelectedEmployee: (state, action) => {
      state.selectedEmployee = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload }
    },
    addEmployee: (state, action) => {
      state.employees.unshift(action.payload)
    },
    updateEmployee: (state, action) => {
      const index = state.employees.findIndex(emp => emp.id === action.payload.id)
      if (index !== -1) {
        state.employees[index] = action.payload
      }
    },
    deleteEmployee: (state, action) => {
      state.employees = state.employees.filter(emp => emp.id !== action.payload)
    },
    clearFilters: (state) => {
      state.filters = {
        department: '',
        status: '',
        search: '',
      }
    },
    clearEmployeeData: (state) => {
      state.employees = []
      state.selectedEmployee = null
    },
  },
})

export const {
  setEmployees,
  setSelectedEmployee,
  setLoading,
  setError,
  setFilters,
  setPagination,
  addEmployee,
  updateEmployee,
  deleteEmployee,
  clearFilters,
  clearEmployeeData,
} = employeeSlice.actions

export default employeeSlice.reducer